import { ILoginFlows } from "../entities/CommonLoginData";
const validateMPINMapper = (data) => {
    if (data) {
        return {
            daysLeft: data.daysLeft,
            status: true,
            userType: ILoginFlows.GUEST,
            guestId: data.unId,
            message: data.msg,
            registeredDate: data.regDt,
        };
    }
    return {};
};
export default validateMPINMapper;
